// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingsCompany__header___1Uqj9"};